import { motion } from 'framer-motion';

/**
 * The "saved" check, drawn in: the green disc pops in, then the tick strokes itself across it. Hand-drawn SVG
 * (not a StrokeIcons glyph) because the draw-on needs the tick's own path.
 */
export function SequenceSavedCheck() {
  return (
    <svg data-saved-check viewBox="0 0 16 16" className="size-3.5 shrink-0" aria-hidden>
      <motion.circle
        cx={8}
        cy={8}
        r={8}
        className="fill-mantis-500"
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ type: 'spring', stiffness: 600, damping: 22 }}
        style={{ transformOrigin: '8px 8px' }}
      />
      <motion.path
        d="M4.6 8.3 7 10.6 11.4 5.8"
        fill="none"
        stroke="white"
        strokeWidth={1.8}
        strokeLinecap="round"
        strokeLinejoin="round"
        initial={{ pathLength: 0 }}
        animate={{ pathLength: 1 }}
        transition={{ delay: 0.12, duration: 0.28, ease: 'easeOut' }}
      />
    </svg>
  );
}
